import { Charts } from './Charts';
import ServicesChartsDataProvider from './contexts/ServicesChartsDataContext';

const ProductionValueWrapper = () => {
    return (
        <ServicesChartsDataProvider>
            <Charts />
        </ServicesChartsDataProvider>
    );
};

export default ProductionValueWrapper;
